module.exports = __webpack_public_path__ + "img/banner-img.e64bfb64.svg";